import React from 'react';
import '../../../css/Form.css';
import Select from 'react-select';
import ERPUtils from '../../../helper/Utils'
const PermanentAddress = (props) => {
	// used States:
	const {
		userDetails,
		onChangeHandler,
		ValidationError,
		states,
		cities,
		SelectHandler,
		countries,
		requiredFields,
		// GenerateRemovePopup,
		getStateFromPincodeData
	} = props;
	return (
		<div>
			<div className="formWrapper">
				<div className="row">
					{/* <div className="col-md-3">&nbsp;</div> */}
					<div className="col-xs-12">
						<h4 className="addressHeader ">
						Permanent Address
						</h4>
					</div>
				</div>
			</div>
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							Address Line1
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className={
								requiredFields.commonErrors[0].permanentLine1ReqError ? (
									'form-control invalid z-depth-3'
								) : (
									'form-control z-depth-3'
								)
							}
							value={userDetails.permanentLine1}
							name="permanentLine1"
							type="text"
							onChange={onChangeHandler}
							maxLength="100"
						/>
						{requiredFields.commonErrors[0].permanentLine1ReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Address Line1 cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							Address Line2
						</label>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className="form-control z-depth-3"
							value={userDetails.permanentLine2}
							name="permanentLine2"
							type="text"
							onChange={onChangeHandler}
							maxLength="100"
						/>
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							Country
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<Select
							className={
								requiredFields.commonErrors[0].permanentCountryReqError ? (
									'invalid z-depth-3'
								) : (
									'z-depth-3'
								)
							}
							value={userDetails.permanentCountry}
							options={countries}
							onChange={(selected) => SelectHandler(selected, 'permanentCountry')}
						/>
						{requiredFields.commonErrors[0].permanentCountryReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Country cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							Zip / Postal Code
						</label>
						<span className="requiredText">*</span>
					</div>
					<div className="col-md-5 col-xs-12">
						<input
							className={
								ValidationError.permanentPincodeError ||
									requiredFields.commonErrors[0].permanentPincodeReqError ? (
									'form-control invalid z-depth-3'
								) : (
									'form-control z-depth-3'
								)
							}
							value={userDetails.permanentPincode}
							name="permanentPincode"
							type="text"
							onChange={(e) => onChangeHandler(e, userDetails?.permanentCountry?.nationality === "Indian")}
							maxLength="20"
							disabled={ERPUtils.isNullorWhiteSpace(userDetails.permanentCountry)}
							onKeyDown={ERPUtils.validateSpecialCharacterInput}
						/>
						{ValidationError.permanentPincodeError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter a valid pincode
							</p>
						) : null}
						{ValidationError.permanentPincodeLengthError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Pincode must be six digit
							</p>
						) : null}
						{requiredFields.commonErrors[0].permanentPincodeReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Pincode cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							City
						</label>
						<span className="requiredText">*</span>
						{/* {((ERPUtils.isNullorWhiteSpace(cities) || cities.length === 0) && ERPUtils.isNullorWhiteSpace(userDetails.permanentCity)
							&& !(userDetails?.permanentCountry?.nationality === "Indian")) ? null :
							<span className="requiredText">*</span>} */}
					</div>
					<div className="col-md-5 col-xs-12">
						{((ERPUtils.isNullorWhiteSpace(cities) || cities.length === 0) && ERPUtils.isNullorWhiteSpace(userDetails.permanentCity)
							&& !(userDetails?.permanentCountry?.nationality === "Indian")) ? (
							<div style={{ display: 'inline' }}>
								<input
									className="form-control z-depth-3"
									value={userDetails.otherPermCity}
									name="otherPermCity"
									type="text"
									onChange={onChangeHandler}
									maxLength="50"
								/>
								{/* <i
									className="fa fa-times" 
									style={{marginLeft: "5px",
											position: "absolute",
											top: "12px",
											right: "-20px"}}
									onClick={()=>GenerateRemovePopup("permCityPopup")}
								/> */}
							</div>
						) : (
							<Select
								className={
									requiredFields.commonErrors[0].permanentCityReqError ? 'invalid z-depth-3' : 'z-depth-3'
								}
								options={cities}
								value={typeof userDetails.permanentCity === 'object' ? userDetails.permanentCity : ERPUtils.getSelect2ItemByID(cities, parseInt(userDetails.permanentCity,10))}
								onChange={(selected) => SelectHandler(selected, 'permanentCity')}
							/>)}
						{requiredFields.commonErrors[0].permanentCityReqError || requiredFields.commonErrors[0].otherPermCityReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />City cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >
			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12">
						<label className="appFormLabel ">
							State
						</label>
						<span className="requiredText">*</span>
						{/* {(ERPUtils.isNullorWhiteSpace(userDetails.permanentState) && !(userDetails?.permanentCountry?.nationality === "Indian")) ?
							null :
							<span className="requiredText">*</span>} */}
					</div>
					<div className="col-md-5 col-xs-12">
						{(ERPUtils.isNullorWhiteSpace(userDetails.permanentState) && !(userDetails?.permanentCountry?.nationality === "Indian")) ? (
							<div style={{ display: 'inline' }}>
								<input
									className="form-control z-depth-3"
									value={userDetails.otherPermState}
									name="otherPermState"
									type="text"
									onChange={onChangeHandler}
									maxLength="100"
								/>
								{/* <i
									className="fa fa-times"
									style={{
										marginLeft: '5px',
										position: 'absolute',
										top: '12px',
										right: '-20px'
									}}
									onClick={() => GenerateRemovePopup('permStatePopup')}
								/> */}
							</div>
						) : (
							<Select
								className={
									requiredFields.commonErrors[0].permanentStateReqError ? (
										'invalid z-depth-3'
									) : (
										'z-depth-3'
									)
								}
								value={typeof userDetails.permanentState === 'object' ? userDetails.permanentState : getStateFromPincodeData(cities,userDetails.permanentState,userDetails.permanentCity)} ///FIX THISSSSSS ON MONDAY
								options={states}
								isDisabled
							// onChange={(selected) => SelectHandler(selected, 'permanentState')}
							/>
						)}
						{requiredFields.commonErrors[0].permanentStateReqError || requiredFields.commonErrors[0].otherPermStateReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />State cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div >


		</div >
	);
};

export default PermanentAddress;
